import React from 'react';
import CRUDDetailPage from '../../../../shared/components/crud/CRUDDetailPage';
import { supplierManagementConfig } from '../config/supplierManagementConfig';
import { SupplierService } from '../../../../shared/services/supplierService';

/**
 * SupplierDetail - URL-based detail page for Suppliers
 * Handles view, edit, and add modes with ID from URL params
 */
export default function SupplierDetail() {
  return (
    <CRUDDetailPage
      config={supplierManagementConfig}
      service={SupplierService}
    />
  );
}
